import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-leo-kids",
  "use": "icon-soc-l1-leo-kids-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-leo-kids\">\r\n  <path fill=\"currentColor\" d=\"M512 128c70 0 128 58 128 128s-58 128-128 128-128-58-128-128 58-128 128-128zm0 320c141 0 256 82 256 184v120H256V632c0-102 115-184 256-184z\" />\r\n  <path fill=\"currentColor\" d=\"M192 800h640v64H192z\" />\r\n  <circle cx=\"360\" cy=\"280\" r=\"28\" fill=\"currentColor\" />\r\n  <circle cx=\"664\" cy=\"280\" r=\"28\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-leo-kids.svg
// module id = yZ5g
// module chunks = 546